/* eslint-disable class-methods-use-this */
import { dedupeMixin } from '@open-wc/dedupe-mixin';

const SPACE_BAR_KEY = ' ';
const TAB_KEY = 'Tab';
const ENTER_KEY = 'Enter';
const DOWN_ARROW_KEY = 'ArrowDown';
const UP_ARROW_KEY = 'ArrowUp';
const ESCAPE_KEY = 'Escape';
const HOME_KEY = 'Home';
const END_KEY = 'End';

export default dedupeMixin(
  (superclass) => class extends superclass {
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.removeEventListener('keydown', this.handleKeydown.bind(this));
    }

    /**
     * Dispatches keyboard events to the correct handlers
     */
    handleKeydown(event) {
      switch (event.key) {
        case ENTER_KEY:
          this.handleEnterKey(event);
          break;
        case SPACE_BAR_KEY:
          this.handleSpaceBarKey(event);
          break;
        case TAB_KEY:
          this.handleTabKey(event);
          break;
        case ESCAPE_KEY:
          this.handleEscapeKey(event);
          break;
        case UP_ARROW_KEY:
          this.handleUpArrowKey(event);
          break;
        case DOWN_ARROW_KEY:
          this.handleDownArrowKey(event);
          break;
        case HOME_KEY:
          this.handleHomeKey(event);
          break;
        case END_KEY:
          this.handleEndKey(event);
          break;
        default:
      }
    }

    handleEnterKey() { /* To be (optionally) overriden by a subclass */ }
    handleSpaceBarKey() { /* To be (optionally) overriden by a subclass */ }
    handleTabKey() { /* To be (optionally) overriden by a subclass */ }
    handleEscapeKey() { /* To be (optionally) overriden by a subclass */ }
    handleUpArrowKey() { /* To be (optionally) overriden by a subclass */ }
    handleDownArrowKey() { /* To be (optionally) overriden by a subclass */ }
    handleHomeKey() { /* To be (optionally) overriden by a subclass */ }
    handleEndKey() { /* To be (optionally) overriden by a subclass */ }
  },
);
